// extracted by mini-css-extract-plugin
module.exports = {"users":"Databases_users__2vv-w","item":"Databases_item__1z0LI","info":"Databases_info__153nc","role":"Databases_role__3cDJr","meta":"Databases_meta__Xw0om"};